/* global gon */

import "app/helpers/compatibility";

import "../../components/desktop/setup";
import { Track } from "../../components/common/track";
import { logFunnelEvent, markLandingRendered, initInteractionTracking } from "../../app/helpers/classes/funnel_tracking";
// air-datepicker and its Swedish locale used to be imported here for the
// jQuery search field. That field is datepicker_controller.js now -- a
// self-contained Stimulus calendar with no air-datepicker dependency
// (grepped: nothing outside the separate iframe pack calls .datepicker()).

// Only the stylesheet is still needed here. The jQuery-UI Searchfield
// widget it used to pull in is gone: every page this pack loads on
// (front, step1, contact -- see ApplicationHelper#webpack_component_files)
// now renders the Stimulus-driven searchfield instead.
import "components/desktop/searchfield/styles/searchfield";

function ready(fn) {
  if (document.readyState !== "loading") fn();
  else document.addEventListener("DOMContentLoaded", fn);
}

ready(() => {
  markLandingRendered(gon.search_id);
  logFunnelEvent("landing_page_loaded", {
    search_id: gon.search_id,
    clicked_price: gon.clicked_price
  });
  if (gon.clicked_price) {
    logFunnelEvent("clicked_price", {
      search_id: gon.search_id,
      clicked_price: gon.clicked_price
    });
  }
  initInteractionTracking();

  // Results rendering (step_1_body) is now server-rendered +
  // step1_results_controller.js (see step_1.html.erb) for every brand --
  // no theme-specific override renders the old empty #step_1_body/Vue
  // mount point anymore (confirmed: no such override exists for any
  // gate). The Vue+Vuex+SearchChannel mount and debug_panel.vue (which
  // only ever showed SearchChannel debug info) are both gone; see git
  // history for the removed code if this ever needs resurrecting.

  // Auto-resubmit when the page was opened with a ?daterange= -- the
  // searchfield renders #trigger-search in that case. See the comment on
  // .main_btn_wide in common/searchfield/_search_field_return.html.erb:
  // that class is a required JS hook, not styling. Deferred a tick so the
  // form's Stimulus controllers have connected before the click lands.
  setTimeout(() => {
    if (document.getElementById("trigger-search")) {
      const searchButton = document.querySelector(".main_btn_wide");
      if (searchButton) searchButton.click();
    }
  }, 1);

  // The hotel-map popup (step1/_hotel_map.html.erb, reached via
  // _itinerary_hotel.html.erb) used to mount falco-webkit's Mapbox-backed
  // <map> Vue component here. That had already been dead for a while: the
  // `Map` import above it was commented out, so `Map` resolved to the
  // JavaScript built-in and the mount could never produce a map. Removed
  // with the rest of Vue rather than left as a listener that throws. The
  // popup still opens and still renders its #map-canvas div -- it just has
  // no map in it, exactly as before. Needs a real replacement (a Stimulus
  // controller over whichever map provider we want) to actually work.

  // The .youth-tooltip element this used to initialise lives in
  // step2/_booking_form.html.erb -- a page this pack never runs on, so the
  // tooltip had in fact never been initialised and the browser was showing
  // its raw HTML-laden `title` as a native tooltip. It is now the shared
  // common/_info_tooltip.html.erb partial (tooltip Stimulus controller).

  // used at multiple places now, maybe we could have it in 1 later
  document.addEventListener("click", function(event){
    if (Array('checkbox', 'radio').includes(event.target.type)) {
      Track.log("Clicked on checkbox: " + event.target.name + " - ischecked: " + event.target.value)
    }
  });

  // Session-timeout warning dialog is now Stimulus-driven (step1-timer
  // controller, wired directly in _session_timer_step1_dialog.html.erb) --
  // no JS needed here anymore, see that controller for the timer/reopen
  // logic this used to do via $.fancybox.open.
});
